import { ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Seta do CTA «Ver power» — cápsula suave, anima no hover do `group`. */
export function PowerCtaArrow({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full',
        'bg-white/[0.07] ring-1 ring-inset ring-white/12',
        'transition-all duration-200 ease-out',
        'group-hover:translate-x-0.5 group-hover:bg-sky-400/15 group-hover:ring-sky-400/30',
        className
      )}
      aria-hidden
    >
      <ArrowRight
        className="h-3.5 w-3.5 text-sky-100/75 transition-colors duration-200 group-hover:text-sky-100"
        strokeWidth={2.25}
      />
    </span>
  );
}
